// extracted by mini-css-extract-plugin
export var standaloneTable = "_26-0";
export var standaloneTableWithBodyFill = "_26-1";
export var withExtraHeader = "_26-2";